import React, { useEffect } from "react";
import { useAuth } from "./auth";
import { Navigate, useLocation } from "react-router-dom";
import { authenticateService } from "./services/CommonService";

const RequireAuth = ({children}) => {
  const {pathname} = useLocation();
  const auth = useAuth();
  useEffect(() => {
    authenticateService().then((res) => {
      if (res.jwt) {
        auth.login("LoggedIn");
      } else {
        auth.logout();
      }
    });
  }, [pathname]);

  if (!auth.user) {
    return <Navigate to="/login" state={{
      path: pathname
    }} />;
  }
  return children;
};

export default RequireAuth;
